import { getInfluxdbData } from '../api/influxdb-tools';

const VERALLIA_DASHBOARD_HISTORY_START = '-365d';

const getInfluxRowTimestamp = (row) => {
  const value = row._time ?? row.time;
  if (!value) return null;

  const timestamp = new Date(value).getTime();
  return Number.isFinite(timestamp) ? timestamp : null;
};

const getNumberOrNull = (value) => {
  if (value === null || value === undefined || value === '') return null;

  const number = Number(value);
  return Number.isFinite(number) ? number : null;
};

const getStringOrNull = (value) => {
  if (value === null || value === undefined || value === '') return null;
  return String(value);
};

const getFirstTagReadByPalletId = (tagRows) => {
  const tagReadsByPalletId = new Map();

  [...tagRows]
    .sort((rowA, rowB) => {
      const timestampA = getInfluxRowTimestamp(rowA) ?? Number.MAX_SAFE_INTEGER;
      const timestampB = getInfluxRowTimestamp(rowB) ?? Number.MAX_SAFE_INTEGER;

      return timestampA - timestampB;
    })
    .forEach((row) => {
      const palletId = getStringOrNull(row.pallet_id);
      if (!palletId || tagReadsByPalletId.has(palletId)) return;

      tagReadsByPalletId.set(palletId, row);
    });

  return tagReadsByPalletId;
};

const getShiftFromEquipo = (equipo) => {
  const shift = Number(equipo);
  return [1, 2, 3].includes(shift) ? shift : null;
};

export const formatVeralliaDashboardInfluxDetections = (defectRows, tagRows) => {
  const tagReadsByPalletId = getFirstTagReadByPalletId(tagRows);

  return defectRows
    .filter((row) => row.detected === true || row.detected === 'true')
    .map((row) => {
      const id = getStringOrNull(row.defect_id);
      const palletId = getStringOrNull(row.pallet_id);
      const timestampMs = getInfluxRowTimestamp(row);
      const tagRead = tagReadsByPalletId.get(palletId);

      return {
        id,
        timestamp: timestampMs === null ? null : Math.floor(timestampMs / 1000),
        palletId,
        defect: getNumberOrNull(row.defect_type),
        face: getNumberOrNull(row.face),
        size: getNumberOrNull(row.diameter_cm),
        image: id ? `${process.env.REACT_APP_FILE_URL}defects/${id}.jpg` : null,
        fechaFabricacion: getStringOrNull(tagRead?.fecha_fabricacion),
        shift: getShiftFromEquipo(tagRead?.equipo),
        lote: getStringOrNull(tagRead?.lote),
        linea: getStringOrNull(tagRead?.linea),
        transferLine: getStringOrNull(row.line),
        numeroPalet: getStringOrNull(tagRead?.numero_palet),
      };
    })
    .filter(({ id, timestamp }) => id && timestamp !== null);
};

export const getVeralliaDashboardInfluxDetections = async () => {
  const [tagRows, defectRows] = await Promise.all([
    getInfluxdbData(
      'engine',
      'pallet_tag_read',
      [],
      ['numero_palet', 'linea', 'equipo', 'fecha_fabricacion', 'lote'],
      VERALLIA_DASHBOARD_HISTORY_START,
      'now()',
      null,
    ),
    getInfluxdbData(
      'engine',
      'pallet_defect',
      [],
      ['detected', 'diameter_cm'],
      VERALLIA_DASHBOARD_HISTORY_START,
      'now()',
      null,
    ),
  ]);

  return formatVeralliaDashboardInfluxDetections(defectRows, tagRows);
};